import {
  applyRuntimeOverrides,
  captureRuntimeDefaults,
  deepFreeze
} from "./runtime-overrides";

export async function findRuntimeSettings(
  publicPath = "/"
): Promise<RuntimeSettings> {
  const runtime = await fetch(`${publicPath}runtime.json`).then(
    res => res.json() as Promise<RuntimeSettings>,
    () =>
      ({
        gateway: "/",
        cdn: "",
        backend: "/backend/",
        environment: "production"
      } as RuntimeSettings)
  );
  captureRuntimeDefaults(runtime);
  return deepFreeze(applyRuntimeOverrides(runtime));
}
